import { ColumnDef } from "@tanstack/react-table";
import { formatDateMonthYear } from "@utils/formatDate";
import { usePartnerStore } from "@store/partnerStore";
import { formatNumberDecimals } from "@utils/formatNumber";

export interface InvoiceMonth {
  month: string;
  amount: number;
}

export interface Invoice {
  id: number;
  periodEnd: string;
  total: number;
  months: InvoiceMonth[];
}

export const InvoiceTableColumns = (): ColumnDef<Invoice>[] => {
  const { currency } = usePartnerStore();

  return [
    {
      accessorKey: "id",
      header: "ID",
      enableSorting: true,
      cell: ({ row }) => {
        const invoice = row.original;
        return <div className="font-medium font-mono text-gray-900">#{invoice.id}</div>;
      },
    },
    {
      accessorKey: "periodEnd",
      header: "Period",
      enableSorting: true,
      cell: ({ row }) => {
        const invoice = row.original;
        return (
          <div className="font-medium text-gray-900">
            {formatDateMonthYear(invoice.periodEnd)}
          </div>
        );
      },
    },
    {
      accessorKey: "total",
      header: "Total",
      enableSorting: true,
      cell: ({ row }) => {
        const invoice = row.original;
        return (
          <div className="font-medium text-gray-900">
            {formatNumberDecimals(invoice.total)}
            {currency && (
              <span className="ml-1 text-gray-600">{currency}</span>
            )}
          </div>
        );
      },
    },
  ];
};

